import request from '@/utils/shouye_request'
//封装接口数据
export function getH5IndexDatas(params){
    return request({
        url:'/index/index/getH5Index',
        method:'GET',
        params
    })
}
export function getzhibo(params){
    return request({
        url:'/edu/lesson/getLiveList',
        method:'GET',
        params
    })
}

